import MaintenanceVerification from "../../../maintenance/shared/MaintenanceVerification";

function IntroductionVerification({data}) {
    return <MaintenanceVerification data={data} variant="introduction" />;
}

export {IntroductionVerification};
